// src/store.ts
import { configureStore } from '@reduxjs/toolkit';
import onlineStatusReducer from './store/onlineStatusSlice';

export const store = configureStore({
    reducer: {
        onlineStatus: onlineStatusReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;